import React from 'react'

import Img from 'components/base/Img'

import {
  TeamMemberName,
  TeamMemberTitle,
  TeamMemberTopWrap,
} from './styles'

import { Props } from './types'

const TeamMemberTop: React.FC<Props> = ({
  image,
  name,
  title,
}): React.ReactElement => (
  <TeamMemberTopWrap>
    <Img src={image} src2x={undefined} alt={name} />
    <TeamMemberName>{name}</TeamMemberName>
    <TeamMemberTitle>{title}</TeamMemberTitle>
  </TeamMemberTopWrap>
)

export default TeamMemberTop
